<lib-icon-button
    iconName="close"
    [color]="color"
    [rippleColor]="color"
    [backgroundColor]="backgroundColor"
    [backgroundHoverColor]="color"
    [backgroundFocusedColor]="color"
    [border]="false"
    [useFillAsStrokeColor]="true"
    (onClick)="onCloseClick()"
    [buttonSize]="buttonSize"
    [size]="iconSize"
    display="circle" />
